"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessagePanelContext = void 0;
const react_1 = require("react");
exports.MessagePanelContext = (0, react_1.createContext)({});
